<template>
  <v-container grid-list-md>
    <!-- <v-card >
             <v-toolbar
                     card
                     color="blue darken-3"
                     dark>

                 <v-toolbar-title>My Inspection Sites</v-toolbar-title>

             </v-toolbar>

             <gmap-map
                     :center="center"
                     :zoom="10"
                     style="width:100%;  height: 400px;">
                 <gmap-marker
                         :key="index"
                         v-for="(m,index) in markers"
                         :position="m.position"
                         @click="center=m.position"
                         :icon="{ url: require('../assets/blue-dot.png')}"
                 ></gmap-marker>
             </gmap-map>
         </v-card>-->
    <v-card class="mt-5">
      <v-toolbar color="blue darken-3" dark>
        <v-toolbar-side-icon></v-toolbar-side-icon>

        <v-toolbar-title> Inspection Sites</v-toolbar-title>

        <v-spacer></v-spacer>
      </v-toolbar>

      <v-list two-line>
        <template v-for="(item, index) in items">
          <v-list-tile :key="index + '-site'" avatar ripple>
            <v-list-tile-action>
              <v-icon color="grey darken-2">place</v-icon>
            </v-list-tile-action>

            <v-list-tile-content>
              <v-list-tile-title>{{ item.title }}</v-list-tile-title>
              <v-list-tile-sub-title class="text--primary">{{
                item.address
              }}</v-list-tile-sub-title>
            </v-list-tile-content>

            <v-list-tile-action class="pl-2 pr-2">
              <v-btn
                color="blue darken-2 white--text pl-3 pr-3"
                slot="activator"
              >
                <v-icon class=" pr-2">email</v-icon> Request
              </v-btn>
            </v-list-tile-action>
          </v-list-tile>

          <v-divider
            v-if="index + 1 < items.length"
            :key="index + '-enddivider'"
          ></v-divider>
        </template>
      </v-list>
    </v-card>
  </v-container>
</template>

<script>
import axios from "axios";
import { config } from "../config/config";
import jwt_decode from "jwt-decode";
import { checkLogin } from '../helpers/check'

export default {
  name: "Sites",
  data() {
    return {
      portalUrl: config.insApiUrl,
      picker: "2019-05-01",
      picker2: "2019-05-01",
      currentSite: "",
      currentBuilding: "",
      buildingData: {
        lof: "",
        hvac: "",
        drawings: "",
        floor: "",
        area: "",
        elevation: "",
        storeys: "",
        upgrade: "",
        basement: { id: "", text: "" }
      },
      siteData: {
        region: "",
        salt: "",
        inundation: { id: "", text: "" },
        sth: "",
        hat: "",
        lsp: "",
        jetty: ""
      },
      regions: ["A", "B", "C", "D"],
      distances: [
        "Less than 100 m",
        "100 to 200 m",
        "200 to 500 m",
        "More than 500 m"
      ],
      binary: [
        {
          id: 0,
          text: "Yes"
        },
        {
          id: 1,
          text: "No"
        }
      ],
      binary2: [
        {
          id: 0,
          text: "Yes"
        },
        {
          id: 1,
          text: "No"
        }
      ],
      upgrades: [
        "No upgrade",
        "Before 1970",
        "1970 to 1984",
        "1985 to 1999",
        "After 2000",
        "Unknown date of upgrade"
      ],
      areas: [
        "less than 100 m square",
        "100 m2 to 200 m square",
        "200 m2 to 500 m square",
        "500m2 to 1000 m square",
        "1000 m2 to 2000 m square",
        "greater than 2000 m square"
      ],
      hvacs: [
        "No centralised HVAC",
        "Basement",
        "Ground level external to the building",
        "Ground level within the building",
        "Mounted on the roof",
        "Inside on upper floors"
      ],
      floors: [
        "Carpet",
        "Timber",
        "Material other than those listed",
        "Lino or vinyl",
        "Tiles",
        "Concrete"
      ],
      dialog: false,
      dialog1: false,
      dialog3: false,
      dialog4: false,
      dialog5: false,
      center: { lat: -19.258965, lng: 146.816956 },
      markers: [],
      places: [],
      currentPlace: null,
      items: []
    };
  },

  mounted() {
    if (checkLogin()) {
      router.push("/login");
    }
    else {
      axios.defaults.headers.common["Authorization"] =
        "JWT " + sessionStorage.getItem("token");
      axios
        .get(this.portalUrl + "sites/")
        .then(res => {
          this.items = res.data;
        })
        .catch(e => {
          this.loading = false;
        });
    }
  },

  methods: {
    getItemText() {
      //console.log(this.inundation)
    },
    schedule(index) {},
    remove(index) {
      this.items.splice(index, 1);
      this.markers.splice(index, 1);
    },
    removeBuilding(inner, index) {
      this.items[index].buildings.splice(inner, 1);
    },
    addBuilding(index) {
      this.items[index].buildings.push({
        //action: 'Add Info',
        address: "Building",
        //title: 'Building',
        subtitle: "Pending Inspection",
        status: "initiated",
        buildingData: {
          lof: "",
          hvac: "",
          drawings: "",
          floor: "",
          area: "",
          elevation: "",
          storeys: "",
          upgrade: "",
          basement: ""
        }
      });
    },
    setPlace(place) {
      this.currentPlace = place;
    },
    addMarker() {
      if (this.currentPlace) {
        const marker = {
          lat: this.currentPlace.geometry.location.lat(),
          lng: this.currentPlace.geometry.location.lng()
        };
        this.markers.push({ position: marker });
        this.items.push({
          address: this.currentPlace.formatted_address,
          title: "Site",
          subtitle: "Pending Inspection",
          status: "initiated",
          siteData: {
            region: "",
            salt: "",
            inundation: "",
            sth: "",
            hat: "",
            lsp: "",
            jetty: ""
          },
          buildings: [],
          date1: "",
          date2: ""
        });
        //this.places.push(this.currentPlace);
        this.center = marker;
      }
    },
    geolocate: function() {
      /*navigator.geolocation.getCurrentPosition(position => {
                    this.center = {
                        lat: position.coords.latitude,
                        lng: position.coords.longitude
                    };
                });*/
    },
    inspectToken() {
      const token = this.$session.has("token");
      if (token) {
        const decoded = jwt_decode(sessionStorage.getItem("token"));
        const exp = decoded.exp;
        const orig_iat = decoded.orig_iat;

        if (exp - Date.now() / 1000 < 1800) {
          return true;
        } else {
          return false;
        }
      } else {
        return true;
      }
    }
  }
};
</script>
